import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TIME_DASH_VIEW_COLORS, TIME_DASH_VIEW_LEGEND } from '@awp/constants';
import { useSelector } from 'react-redux';
import { selectFullScreen } from '@awp/stores/fullScreenSlice';
const TimeBasedLegend = ({ isMedium }) => {
  const fullScreen = useSelector(selectFullScreen);
  return (
    <>
      <Row>
        {TIME_DASH_VIEW_LEGEND.map((l, index) => (
          <Col xs={fullScreen.enabled && isMedium ? 2 : 6} key={index}>
            <LegendItem color={TIME_DASH_VIEW_COLORS[index]} label={l} isMedium={isMedium} />
          </Col>
        ))}
      </Row>
    </>
  );
};

const LegendItem = ({ color, label, isMedium }) => {
  const fullScreen = useSelector(selectFullScreen);
  const font = { fontSize: fullScreen.enabled || !isMedium ? (isMedium ? '12px' : '10px') : '17px' };
  const position = { display: 'flex', alignItems: 'center', marginBottom: '5px' };
  return (
    <div style={position}>
      <div
        style={{
          width: !isMedium ? '13px' : '20px',
          height: !isMedium ? '13px' : '20px',
          backgroundColor: color,
          marginRight: '10px',
        }}
      ></div>
      <span style={font}>{label}</span>
    </div>
  );
};

export default TimeBasedLegend;
